// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__SptZG","children":"style_children__lKzWU","image":"style_image__1CdHB","image_section":"style_image_section__wBHev"};